<template>
  <div class="grid-x grid-margin-x">
    <div class="cell medium-4">
      <card-item :title="$t('interface.favicon')" icon="icon-interface-logo">
        <div style="color:#cecece; margin-bottom:30px;">{{ $t('interface.favicon_size_requirements') }}</div>
        <div class="vue-dropzone-single">
          <ab-dropzone
            :data="content.favicon"
          />
        </div>
      </card-item>
    </div>

    <div class="cell medium-4">
      <card-item :title="$t('interface.menu_logo')" icon="icon-interface-logo">
        <div class="vue-dropzone-single">
          <ab-dropzone
            :data="content.menu_logo"
            @image-removed="settings.menu_logo = {}"
          />
        </div>
      </card-item>
    </div>

    <div class="cell medium-4">
      <card-item :title="$t('interface.login_screen_logo')" icon="icon-interface-logo">
        <div class="vue-dropzone-single">
          <ab-dropzone
            :data="content.login_screen_logo"
            @image-removed="settings.login_screen_logo = {}"
          />
        </div>
      </card-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InterfaceSettingsLogos',
  props: ['content'],
  data () {
    return {
      loginTypeBackground: [
        {
          title: this.$t('app.background_color'),
          value: 'color'
        },
        {
          title: this.$t('app.background_image'),
          value: 'image'
        }
      ]
    }
  },
  mounted () {
    if (Array.isArray(this.content.login_screen_logo)) {
      this.settings.login_screen_logo = {}
    }
    if (Array.isArray(this.content.menu_logo)) {
      this.settings.menu_logo = {}
    }
    if (Array.isArray(this.content.favicon)) {
      this.settings.favicon = {}
    }
  },
  computed: {
    settings: {
      get () {
        return this.content
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
